import { useEffect, useState } from 'react';
import reduce from 'lodash/reduce';
import set from 'lodash/set';
import mapValues from 'lodash/mapValues';

import convertErrors from '../components/PatientRegistration/utils/convertErrors';
import { PROFILE_FIELDS_TYPES } from '../constants/formFields';
import homePhoneValidator from '../utils/validations/homePhoneValidator';
import ruleForSSN from '../utils/validations/ruleForSSN';
import ruleForUserName from '../utils/validations/ruleForUserName';
import { PATTERNS } from '../constants/validations';

import useDidUpdate from '../hooks/useDidUpdate';

const validationRules = {
  [PROFILE_FIELDS_TYPES.SSN]: ruleForSSN,
  [PROFILE_FIELDS_TYPES.HOME_PHONE]: homePhoneValidator,
  [PROFILE_FIELDS_TYPES.FIRST_NAME]: ruleForUserName,
  [PROFILE_FIELDS_TYPES.LAST_NAME]: ruleForUserName,
};

export function useInitialState(initialFields) {
  const [initialState, setInitialState] = useState({});

  useEffect(() => {
    setInitialState(
      reduce(initialFields, (result, value) => set(result, value, ''), {}),
    );
  }, []);

  return initialState;
}

export function useFormState(initialState = {}) {
  const [formState, setPatientInfo] = useState(initialState);
  function handleFormChange(value) {
    setPatientInfo({ ...formState, ...value });
  }

  function clearForm() {
    setPatientInfo(mapValues(formState, () => ''));
  }

  return { formState, handleFormChange, clearForm };
}

export function useFormValidation(serverErrors) {
  const [validateErrors, setValidateErrors] = useState({});

  useEffect(() => {
    if (serverErrors) {
      setValidateErrors(convertErrors(serverErrors));
    }
  }, [serverErrors]);

  const addLocalValidateErrors = (name, errors) => {
    setValidateErrors({
      ...validateErrors,
      [name]: errors,
    });
  };

  function clearErrors() {
    setValidateErrors({});
  }

  return { validateErrors, clearErrors, addLocalValidateErrors };
}

export const makeRequiredFieldsValidator = fieldList => patientData =>
  fieldList.every(type => Boolean(patientData[type]));

export const makeLocalFieldsValidation = fieldList => patientData => {
  return fieldList.every(type => {
    const required = Boolean(patientData[type]);

    const rule = validationRules[type];
    return rule ? rule(patientData[type]) : required;
  });
};

export const clearValidationErrorsOnChange = (clear, formState) => {
  useDidUpdate(() => {
    clear();
  }, formState);
};

export const validateField = (fieldName, value) => {
  const rule = PATTERNS[fieldName];
  if (!rule) return true;
  return rule.test(value);
};



// WEBPACK FOOTER //
// ./src/hocs/useFormWithValidation.js